// extracted by mini-css-extract-plugin
module.exports = {"base":"_02712f2b3b--base--_8_8v","triangle":"_02712f2b3b--triangle--UDnIt","content":"_02712f2b3b--content--NW2AD","close":"_02712f2b3b--close--_rLgP"};